import type { CSSProperties, MouseEvent } from 'react'
import styled from 'styled-components'

import { Color } from '../../theme/color'
import type { ColorKeys } from '../../theme/color'

interface CardProps {
  $block?: boolean
  $direction?: CSSProperties['flexDirection']
  $gap?: number
  $padding?: CSSProperties['padding']
  $border?: boolean
  $borderStyle?: CSSProperties['borderStyle']
  $borderWidth?: number
  $borderColor?: ColorKeys
  $radius?: number
  $background?: ColorKeys
  $shadow?: CSSProperties['boxShadow']
  children?: React.ReactNode
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
}

export function Card({ $block = true, $direction = 'row', children, ...props }: CardProps) {
  return (
    <Container $block={$block} $direction={$direction} {...props}>
      {children}
    </Container>
  )
}

export const Container = styled.div<CardProps>`
  display: ${({ $block }) => ($block ? 'flex' : 'inline-flex')};
  flex-direction: ${({ $direction }) => $direction};
  ${({ $gap }) => ($gap ? `gap: ${$gap}px;` : '')}
  ${({ $padding }) => ($padding ? `padding: ${$padding};` : '')}
  ${({ $radius }) => ($radius ? `border-radius: ${$radius}px;` : '')}
  ${({ $border, $borderWidth, $borderStyle, $borderColor }) =>
    `
      ${
        $border
          ? `
          border-width: ${$borderWidth}px;
          border-style: ${$borderStyle ?? 'solid'};
          border-color: ${$borderColor ? Color[$borderColor] : 'transparent'};
        `
          : ''
      }
    `}
    ${({ $background }) => ($background ? `background: ${Color[$background]};` : '')}
    ${({ $shadow }) => ($shadow ? `box-shadow: ${$shadow};` : '')}
`
Card.styled = Container
